<template>
  <form @submit.prevent="handleSubmit" @keydown.enter.prevent>
    <div class="header mb-3">
      <div class="d-flex justify-content-between">
        <div class="one-third-block"></div>
        <h1>請求書</h1>

        <div class="one-third-block">
          <div class="text-end mb-2">
            <div class="text-end flex-end">
              <label for="billing_dt_display_flg" class="ECM_CheckboxInput justify-content-end">
                <input
                  v-model="localData.billing_dt_display_flg"
                  :true-value="true"
                  :false-value="false"
                  id="billing_dt_display_flg"
                  type="checkbox"
                  class="ECM_CheckboxInput-Input"
                >
                <span class="ECM_CheckboxInput-DummyInput"></span>
                <h4 class="mx-2 text-end">請求日表示</h4>
              </label>

              <!-- 請求年と請求月 -->
              <input v-model="localData.billing_year" type="hidden">
              <input v-model="localData.billing_month" type="hidden">
            </div>
            <div v-if="localData.billing_dt_display_flg === true">
              <input
                v-model="localData.billing_dt"
                type="date"
                class="form-control"
                max="2099-12-31"
                required
              >
            </div>
          </div>
          <p class="text-end mb-0">請求番号 {{ localData.parent_billing_no }}</p>
        </div>
      </div>

      <div class="d-flex justify-content-between mb-3">
        <div class="annual-bill-customer-rep mb-0 d-flex align-items-center">
          <!-- 顧客名(請求先) 御中 -->
          <div class="mb-3">
            <div class="d-flex align-items-center mb-1">
              <CustomerSelectBox
                v-model="localData.m_customer_id"
                :options="customers"
                :required="true"
              />
              <span class="text-nowrap ms-2">
                <input v-model="localData.honorific_title" type="text" placeholder="敬称" class="form-control w-third-forth" id="honorificTitle">
              </span>
            </div>
            <div class="text-danger">※顧客マスタ登録がある場合のみ、自動反映されます</div>
          </div>
        </div>
      </div>

      <div class="middle-title d-flex justify-content-between">
        <h4 class="mb-1 text-nowrap">下記の通り御請求申し上げます。</h4>
        <div class="text-end">
          <div class="company-info-block ">
            <div>
              <label for="representative_nm_display_flg" class="ECM_CheckboxInput d-flex justify-content-end align-items-center">
                <input
                  v-model="localData.representative_nm_display_flg"
                  :true-value="true"
                  :false-value="false"
                  id="representative_nm_display_flg"
                  type="checkbox"
                  class="ECM_CheckboxInput-Input"
                >
                <span class="ECM_CheckboxInput-DummyInput"></span>
                <h4 class="mx-2 bank-checktitle">代表取締役表示</h4>
              </label>
            </div>
            <h4 class="billing-company-nm">株式会社 創英企画</h4>
            <div v-if="localData.representative_nm_display_flg === true">
              <h6 class="billing-company-representative">代表取締役 鈴木 明</h6>
            </div>
            <p class="billing-company-address"><span class="me-4">〒 151-0053</span><span>東京都渋谷区代々木2-38-6</span></p>
            <p class="billing-company-address"><span class="me-4">TEL 03-3370-8006</span><span>FAX 3370-8157</span></p>
          </div>
          <span class="company-regist-no">登録番号 T7011001012662</span>
        </div>
      </div>
    </div>

    <div class="total-billing-amount-area mb-2">
      <div>
        <h1 class="total-billing-amount">合計金額 {{ formatCurrency(calculateGrandTotal()) }}</h1>
      </div>
      <div class="d-flex align-items-center carryover-amount">
        <h5 class="mb-0">繰越金額</h5> 
        <div class="d-flex align-items-center">
          <CommaNumberInput
            v-model="localData.carryover_amount"
            placeholder="繰越金額"
            @input="updateTotals"
            class="form-control"
            id="carryover_amount_input"
          />
        </div>
      </div>
    </div>

    <!-- 業務内容のテーブル -->
    <div>
      <table class="table table-bordered monthly-detail-data">
        <thead>
          <tr>
            <th class="month-data-header text-nowrap">請求ID<br><span class="text-danger">臨時作業のみ</span></th>
            <th class="month-data-header text-nowrap">建物</th>
            <th class="month-data-header work-date">日付<br><span class="text-danger">業者/顧客予定表の作業日がある場合、日付が入ります</span></th>
            <th class="month-data-header text-nowrap">摘要</th>
            <th class="month-data-header text-nowrap">内訳</th>
            <th class="month-data-header text-nowrap bill-amount">金額</th>
            <th class="month-data-header text-nowrap">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(billing, index) in localData.t_customer_monthly_billing_details"
            :key="billing.client_row_key || index"
            :class="{ 'annual-work-cancel-row': billing.cancel_annual_work }"
          >
            <!-- 請求番号 -->
            <td class="text-nowrap">{{ billing.billing_no }}</td>

            <!-- 建物列：最初の1回だけ表示して rowspan -->
              <!-- ▼ 建物列：分岐ロジックを整理 -->
              <template v-if="billing.work_type == 2">
                <!-- 追加行はそのままセレクトボックス表示（rowspanなし） -->
                <td class="text-start">
                  <BuildingSelectBox
                    v-model="billing.m_building_id"
                    :options="buildings"
                  />
                </td>
              </template>
              <template
                v-else-if="groupedBillings[index]"
              >
                <!-- 初期表示の行、かつ最初の行のみ rowspan -->
                <td
                  class="text-start"
                  :rowspan="groupedBillings[index].count"
                >
                  <input type="hidden" v-model="billing.m_building_id" />
                  {{ billing.m_building?.building_nm || '' }}
                </td>
              </template>

            <!-- 初期行だけど rowspan 対象ではない（tdスキップ） -->
            <!-- tdなし（空）＝rowspanに含まれている行 -->

            <!-- 作業日と作業年月 -->
            <td class="work-date">
              <input
                v-model="billing.work_dt"
                type="date"
                class="form-control"
                max="2099-12-31"
                :disabled="billing.cancel_annual_work"
              >
              <input v-model="billing.work_year" type="hidden">
              <input v-model="billing.work_month" type="hidden">
            </td>

            <!-- 作業内容 -->
            <td>
              <span v-if="billing.t_building_work_schedule_detail_id" class="multiline-text text-nowrap">
                {{ billing.work_content }}
              </span>
              <textarea
                v-else
                v-model="billing.work_content"
                class="form-control"
                rows="2"
                :disabled="billing.cancel_annual_work"
                @keydown.enter.stop
              ></textarea>
            </td>

            <!-- 内訳 -->
            <td>
              <textarea
                v-model="billing.breakdown"
                class="form-control"
                rows="2"
                :disabled="billing.cancel_annual_work"
                @keydown.enter.stop
              ></textarea>
            </td>

            <!-- 請求金額 -->
            <td class="bill-amount">
              <div class="d-flex align-items-center">
                <CommaNumberInput
                  v-model="billing.bill_amount"
                  placeholder="請求金額(税抜)"
                  class="form-control"
                  :disabled="billing.cancel_annual_work"
                />
              </div>
            </td>

            <!-- 年間予定作業は中止予定をトグル、追加行は単純削除 -->
            <td>
              <span
                v-if="billing.fixed_fee_summary"
                class="fixed-fee-summary-badge"
                title="予定作業を中止しても、この定額請求の金額は維持されます"
              >定額</span>
              <label
                v-else-if="billing.work_type === 0 && billing.annual_work_cancellation_allowed"
                class="annual-cancel-check"
                :title="billing.fixed_fee_billing ? '作業明細を除外して予定を中止します。定額請求の金額は変わりません' : '作業明細を請求から除外して予定を中止します'"
              >
                <input v-model="billing.cancel_annual_work" type="checkbox" class="form-check-input">
                <span>{{ billing.cancel_annual_work ? '中止予定' : '中止' }}</span>
              </label>
              <button
                v-else-if="billing.work_type === 2"
                type="button"
                class="btn btn-danger btn-sm text-nowrap"
                @click="removeBillingRow(index)"
              >
                削除
              </button>
            </td>
          </tr>
          <tr>
            <td colspan="7" class="text-center">
              <button type="button" class="btn btn-primary btn-sm"  @click="$emit('add-row')">請求項目を追加</button>
            </td>
          </tr>
          <tr>
            <td colspan="5">小計</td>
            <td class="text-end">
              {{ formatCurrency(localData.total_amount) }}
              <input type="hidden" v-model="localData.total_amount" readonly class="form-control">
            </td>
            <td></td>
          </tr>
          <tr>
            <td colspan="5">
              <div class="d-flex align-items-center justify-content-center">
                <p class="mb-0 me-2 text-nowrap">消費税</p>
                <input type="number" v-model="localData.tax_rate" @input="updateTotals" class="form-control tax-input me-2">
                <span>%</span>
              </div>
            </td>
            <td class="text-end">{{ formatCurrency(calculateTax()) }}</td>
            <td></td>
          </tr>
          <tr>
            <td colspan="5">合計</td>
            <td class="text-end">
              {{ formatCurrency(calculateNoCarryoverTotal()) }}
              <input type="hidden" v-model="localData.billing_total_amount" readonly class="form-control">
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div>
      <p class="mb-1">代金は下記当社取引銀行口座にお振込下さる様お願い致します。</p>

      <!-- 振込先１ -->
      <div v-if="localData.bank_display_flg_01 === true">
        <p class="d-flex align-items-center mb-1">
          <span class="me-2">{{ localData.bank_nm_01 }}</span>
          <span class="me-2">{{ localData.branch_nm_01 }}</span>
          <span class="me-2">{{ localData.account_type_01 }}</span>
          <span class="me-2">{{ localData.account_no_01 }}</span>
        </p>
        <input type="hidden" v-model="localData.bank_nm_01" class="form-control" placeholder="銀行名">
        <input type="hidden" v-model="localData.branch_nm_01" class="form-control" placeholder="支店名">
        <input type="hidden" v-model="localData.account_type_01" class="form-control" placeholder="口座種別">
        <input type="hidden" v-model="localData.account_no_01" class="form-control" placeholder="口座番号">
      </div>

      <!-- 振込先２ -->
      <div v-if="localData.bank_display_flg_02 === true">
        <p class="d-flex align-items-center mb-1">
          <span class="me-2">{{ localData.bank_nm_02 }}</span>
          <span class="me-2">{{ localData.branch_nm_02 }}</span>
          <span class="me-2">{{ localData.account_type_02 }}</span>
          <span class="me-2">{{ localData.account_no_02 }}</span>
        </p>
        <input type="hidden" v-model="localData.bank_nm_02" class="form-control" placeholder="銀行名">
        <input type="hidden" v-model="localData.branch_nm_02" class="form-control" placeholder="支店名">
        <input type="hidden" v-model="localData.account_type_02" class="form-control" placeholder="口座種別">
        <input type="hidden" v-model="localData.account_no_02" class="form-control" placeholder="口座番号">
      </div>

      <!-- 振込先３ -->
      <div v-if="localData.bank_display_flg_03 === true">
        <p class="d-flex align-items-center mb-1">
          <span class="me-2">{{ localData.bank_nm_03 }}</span>
          <span class="me-2">{{ localData.branch_nm_03 }}</span>
          <span class="me-2">{{ localData.account_type_03 }}</span>
          <span class="me-2">{{ localData.account_no_03 }}</span>
        </p>
        <input type="hidden" v-model="localData.bank_nm_03" class="form-control" placeholder="銀行名">
        <input type="hidden" v-model="localData.branch_nm_03" class="form-control" placeholder="支店名">
        <input type="hidden" v-model="localData.account_type_03" class="form-control" placeholder="口座種別">
        <input type="hidden" v-model="localData.account_no_03" class="form-control" placeholder="口座番号">
      </div>
    </div>

    <!-- ボタンエリア -->
    <div class="btn-area">
      <a class="btn btn-secondary" @click="goBack">戻る</a>
      <button type="submit" class="btn btn-warning mx-1" :disabled="isSubmitting">
        {{ isSubmitting ? '更新中...' : '請求情報更新' }}
      </button>
    </div>

  </form>
</template>

<script setup>
import { calculateBillingAmounts } from '@/utils/billingAmounts';
import { reactive, computed, defineProps, defineEmits } from 'vue';
import BuildingSelectBox from '@/components/searchSelectBoxes/BuildingSelectBox.vue';
import CustomerSelectBox from '@/components/searchSelectBoxes/CustomerSelectBox.vue';
import CommaNumberInput from '@/components/shared/CommaNumberInput.vue';
import { buildConsecutiveBuildingGroups } from '@/utils/monthlyBillingDetails';

const props = defineProps({
  customerMonthlyBillingData: Object,
  buildings: Array,
  customers: Array,
  isSubmitting: Boolean
});

const emit = defineEmits(['add-row', 'remove-row', 'update-totals', 'go-back', 'submit']);

const localData = reactive(props.customerMonthlyBillingData);
const groupedBillings = computed(() => buildConsecutiveBuildingGroups(localData.t_customer_monthly_billing_details || []));

const formatCurrency = (value) => {
  if (value) {
    return new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(value);
  }
  return '¥0';
};

const calculateTax = () => calculateBillingAmounts(localData).tax_amount;

const calculateNoCarryoverTotal = () => calculateBillingAmounts(localData).current_billing_amount;

const calculateGrandTotal = () => calculateBillingAmounts(localData).billing_total_amount;

const updateTotals = () => {
  emit('update-totals');
};

const handleSubmit = () => {
  emit('submit', localData);
};

const removeBillingRow = (index) => {
  emit('remove-row', index);
};

const goBack = () => {
  emit('go-back');
};
</script>

<style scoped>
.annual-work-cancel-row > td {
  background: #eef1f4 !important;
  color: #7b8491;
}

.annual-work-cancel-row textarea,
.annual-work-cancel-row input:not([type='checkbox']) {
  text-decoration: line-through;
}

.annual-cancel-check {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin: 0;
  padding: 7px 10px;
  border: 1px solid #f1aeb5;
  border-radius: 8px;
  background: #fff5f5;
  color: #b02a37;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}

.annual-cancel-check .form-check-input {
  margin: 0;
  cursor: pointer;
}

.fixed-fee-summary-badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 9px;
  border: 1px solid #9ec5fe;
  border-radius: 999px;
  background: #e7f1ff;
  color: #084298;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

/* ヘッダ */
.header h2 {
  font-weight: bold;
}

.header p {
  text-align: center;
  margin-bottom: 20px;
}

.annual-bill-customer-rep .relative{
  min-width: 500px;
  max-width: 500px;
}

.dear-nm-form{
  min-width: 360px;
}

.header .middle-title .billing-greeting,
.header .middle-title .billing-company-nm,
.header .middle-title .billing-company-representative,
.header .middle-title .billing-company-address {
  font-weight: bold;
}

.header .billing-company-nm,
.header .billing-company-representative,
.header .billing-company-address,
.header .text-end p {
  text-align: justify;
  text-justify: inter-ideograph; /* 日本語対応の両端揃え */
  margin-left: auto; /* text-end に合わせて右寄せ */
  margin-right: 0;
  margin-bottom: 0;
  display: block;
  line-height: 0.8; /* デフォルトは 1.5〜1.6 のことが多い */
}

.header .billing-company-nm::after,
.header .billing-company-representative::after,
.header .billing-company-address::after,
.header .text-end p::after {
  content: '';
  display: inline-block;
  width: 100%;
}

.header .middle-title .billing-greeting{
  font-size: 20px;
  margin-left: 20px;
}
.header .billing-company-nm { font-size: 24px; }
.header .billing-company-representative { font-size: 18px; }
.header .company-regist-no { font-size: 16px; }

.total-billing-amount-area .total-billing-amount{
  display: inline-block;
  border-bottom: 4px solid #000;
}
.total-billing-amount-area .carryover-amount h5{
  min-width: 100px;
}
.total-billing-amount-area .carryover-amount input{
  max-width: 300px;
}

/* テーブルのスタイル */
table {
  border-collapse: collapse;
  width: 100%;
}

th, td {
  padding: 8px;
  border: 1px solid #000;
  text-align: center;
  font-size: 14px;
}
th span {
  font-size: 12px;
}
td input {
  font-size: 14px !important;
}
:deep(.form-control) {
  margin-bottom: 0;
  padding: 6px 12px;
  font-size: 14px;
}

.small-input {
  width: 50px;
}

.month-data-header {
  background-color: #f0f8ff;
  font-weight: bold;
}

.work-date {
  max-width: 160px;
}

.tax-input{
  max-width: 100px;
}

.bill-amount {
  max-width: 130px;
}

.no-resize {
  resize: none;
}

/* ボタンエリア */
.btn-area {
  text-align: right;
  margin-top: 20px;
}

.bank-checktitle{
  min-width: 120px;
  width: 120px;
  max-width: 120px;
}
</style>
